exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.toggle[data-v-0321f23c]{font-size:40px;cursor:pointer\n}\n.toggle-label[data-v-0321f23c]{display:inline-block;padding:2px 0 0 4px;vertical-align:top;font-size:24px;color:#777\n}\n.selected[data-v-0321f23c]{animation:pulse-data-v-0321f23c 0.3s forwards\n}\n@keyframes pulse-data-v-0321f23c{\nfrom{opacity:1\n}\n50%{opacity:0.25\n}\nto{opacity:1\n}\n}\n", ""]);

// exports
